import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartLine16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconChartLine16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M5.916 6.223a.5.5 0 0 0-.88.091l-2 5a.5.5 0 1 0 .928.372l1.647-4.118 1.473 2.21a.5.5 0 0 0 .887-.11l2.106-5.896 1.976 3.952a.5.5 0 0 0 .894-.448l-2.5-5a.5.5 0 0 0-.918.056L7.364 8.394zM2.5 13a.5.5 0 1 0 0 1h11a.5.5 0 0 0 0-1z"
            />
        </svg>
    );
}
export default memo(IconChartLine16);
